module.exports = "<div style=\"filter:blur(3px); -webkit-filter:blur(3px); position:absolute;top:0px;left:0px;right:0px;bottom:0px;background-size: 100% 100%;opacity:0.2\" \n            [ngStyle]=\"{'background-image': 'url(' + bgImage + ')'}\">IMG {{bgImage}}</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/background-image/background-image.component.html
// module id = ../../../../../src/app/core/background-image/background-image.component.html
// module chunks = main